import Vue from 'vue'
import App from './App.vue'
import VueMask from 'v-mask'
Vue.use(VueMask);
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'
import './registerServiceWorker'

Vue.config.productionTip = false

function handleVisibilityChange() {
  if (document.hidden) {
    store.dispatch('offDropSound')
    store.dispatch('updateDocumentVisibility', true)
  }
  else {
    store.dispatch('updateDocumentVisibility', false)
  }
}

document.addEventListener("visibilitychange", handleVisibilityChange, false);


new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
